// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7053":"a130cd1b","7282":"4549c9b0"}[chunkId] + ".css";
};